import {
  SET_ACCESS_TOKEN,
  SET_GUEST_TOKEN,
  SET_IS_LOGGED_IN,
  SET_USER_ID,
  SET_USER_TYPE,
  SET_CUSTOMER_INFO,
  SET_IS_LOADING,
} from "@constants/action-types";

export const initialState = {
  accessToken: "",
  guestToken: "",
  isLoggedIn: false,
  loading: true,
  userId: "",
  userType: "G",
  success: false,
  customerInfo: {
    firstName: "",
  },
};

const AuthReducer = (state, action) => {
  switch (action.type) {
    case SET_ACCESS_TOKEN:
      return {
        ...state,
        accessToken: action.value,
      };
    case SET_GUEST_TOKEN:
      return {
        ...state,
        guestToken: action.value,
      };
    case SET_IS_LOGGED_IN:
      return {
        ...state,
        isLoggedIn: action.value,
        success: true,
      };
    case SET_USER_ID:
      return {
        ...state,
        userId: action.value,
      };
    case SET_USER_TYPE:
      return {
        ...state,
        userType: action.value,
      };
    case SET_CUSTOMER_INFO:
      return {
        ...state,
        customerInfo: action.value,
      };
    case SET_IS_LOADING:
      return {
        ...state,
        loading: action.value,
      };
    default:
      return state;
  }
};

export default AuthReducer;
